module.exports = __webpack_public_path__ + "static/media/afro-latinos-in-movement-petra-rivera.0d1822ec.jpg";